(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["vava-reviews-link"] && !Shopify.designMode) return;
  try {
    (function () {
    // Judge.me renders reviews client-side, so a review count is only knowable at
    // runtime. We flip <html data-vava-reviews> between "none" (default, set here
    // ASAP) and "some". CSS keeps every review affordance collapsed until "some".
    var root = document.documentElement;
    if (!root.hasAttribute('data-vava-reviews')) {
      root.setAttribute('data-vava-reviews', 'none');
    }

    var settled = false;

    function reviewCount() {
      // Preview badge near the price carries an explicit count attribute.
      var badge = document.querySelector('.jdgm-prev-badge[data-number-of-reviews]');
      if (badge) {
        var n = parseInt(badge.getAttribute('data-number-of-reviews'), 10);
        if (!isNaN(n)) return n;
      }
      // Fallback: the widget's histogram / review rows once rendered.
      var widget = document.querySelector('.jdgm-rev-widg');
      if (widget) {
        var attr = parseInt(widget.getAttribute('data-number-of-reviews'), 10);
        if (!isNaN(attr)) return attr;
        if (widget.querySelector('.jdgm-rev')) return 1; // at least one review row
      }
      return null; // unknown so far
    }

    function apply(count) {
      if (settled) return;
      if (count === null) return; // stay hidden until we actually know
      settled = true;
      root.setAttribute('data-vava-reviews', count > 0 ? 'some' : 'none');
      cleanup();
    }

    var observer = null;
    var pollId = null;
    var timeoutId = null;

    function cleanup() {
      if (observer) { observer.disconnect(); observer = null; }
      if (pollId) { clearInterval(pollId); pollId = null; }
      if (timeoutId) { clearTimeout(timeoutId); timeoutId = null; }
    }

    function check() { apply(reviewCount()); }

    // 1) Observe DOM mutations — Judge.me injects its markup asynchronously.
    if ('MutationObserver' in window) {
      observer = new MutationObserver(check);
      observer.observe(document.documentElement, { childList: true, subtree: true });
    }

    // 2) Short polling as a belt-and-braces fallback.
    pollId = setInterval(check, 400);

    // 3) Judge.me ready hook when present.
    document.addEventListener('jdgm.ready', check);
    document.addEventListener('DOMContentLoaded', check);

    // 4) Give up after a while: if the count never resolves, stay in the default
    //    hidden state (settle to 0) so no empty widget whitespace lingers.
    timeoutId = setTimeout(function () {
      var count = reviewCount();
      settled = true;
      root.setAttribute('data-vava-reviews', (count && count > 0) ? 'some' : 'none');
      cleanup();
    }, 8000);

    check();
  })();
  } catch(e) { console.error(e); }
})();

})();
